export const banklists ={
    data(){
        return{
            banklists:[
                '경남은행',
                '기업은행',
                '광주은행',                
                '국민은행',
                '농협중앙회',                                
                '농업회원조합',                                
                '대구은행',                                  
                '부산은행',
                '산업은행',                              
                '새마을금고',
                '신한은행',                                  
                '신협중앙회',                                 
                '수출입은행',                                  
                '수협중앙회',                                
                '외환은행',                                 
                '우리은행',                                  
                '우체국',                                 
                '전북은행',                                 
                '제주은행',                                 
                '하나은행',                                 
                '한국씨티은행',                                 
                'HSBC은행',                                  
                'sc제일은행',                                  
                '카카오뱅크',                                  
                '케이뱅크'                                     
            ]
        }
    }
}
